import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * React Router v6 ne réinitialise pas le scroll par défaut lors d'un changement
 * de route. Ce composant force le scroll tout en haut à chaque navigation SPA.
 *
 * - `useLayoutEffect` fire AVANT le paint → pas de flash de la page qui apparait
 *   à mi-hauteur avant de remonter.
 * - Respecte les ancres `#hash` (le navigateur gère nativement).
 * - Respecte le bouton retour navigateur (POP) : on ne force pas le scroll,
 *   ce qui restaure la position d'origine attendue.
 * - Utilise les 3 méthodes en parallèle pour cross-browser (Safari legacy inclus).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType(); // "POP" | "PUSH" | "REPLACE"

  useLayoutEffect(() => {
    if (hash) return; // ancre interne → laisse le navigateur gérer
    if (navType === "POP") return; // back/forward → restaure la position

    // Robust cross-browser scroll to top (avoid smooth scrolling animation).
    try {
      window.scrollTo(0, 0);
    } catch { /* noop */ }
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname, hash, navType]);

  return null;
}
